import {Brick, registerBrick} from 'olympe';

/**
 * Get a value from a Map
 */
export default class GetFromMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Map} map
     * @param {string} key
     * @param {function(*)} setValue
     */
    update($, [map, key], [setValue]) {
        // Guards
        if (!(map instanceof Map)) {
            throw new Error('TypeError: the map should be of type Map');
        }
        if (typeof key !== 'string') {
            throw new Error(`Provided key is not a string: ${key}`);
        }

        // get the value
        setValue(map.get(key) ?? null);
    }
}

registerBrick('0193017dc31eeeddb3d8', GetFromMap);
